import { render, staticRenderFns } from "./DistsManage.vue?vue&type=template&id=d82e1a32&scoped=true&"
import script from "./DistsManage.vue?vue&type=script&lang=js&"
export * from "./DistsManage.vue?vue&type=script&lang=js&"
import style0 from "./DistsManage.vue?vue&type=style&index=0&id=d82e1a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82e1a32",
  null
  
)

export default component.exports